// extracted by mini-css-extract-plugin
module.exports = {"container":"SlotSelectionControl_container__2veBJ","notes_container":"SlotSelectionControl_notes_container__2NCz-","slots_container":"SlotSelectionControl_slots_container__y6HD6"};